<template>
    <div class="column-layout">
        <el-form :model="adoptedDevice" ref="adoptedDeviceInfo" :rules="adoptedDeviceRules">
            <div class="content-caption dashed">
                <span>分类信息</span>
                <a class="swb-btn-link" v-if="adoptedDevice.skuId == -1 || adoptedDevice.skuId == null" @click="selectCatInfo()">选择</a>
            </div>
            <div class="simple-form">
                <div class="form-group center ">
                    <div class="form-label">
                        <label class="required">分类名称</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="goodsCatName">
                            <el-input class="width-2x bottom-line" :disabled="true" v-model="adoptedDevice.goodsCatName"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">品牌名称</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="goodsBrandName">
                            <el-input class="width-2x bottom-line" :disabled="true" v-model="adoptedDevice.goodsBrandName"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>商品信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label>组装件</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="asmblAccFlag">
                            <el-radio-group v-model="adoptedDevice.asmblAccFlag" :disabled="adoptedDevice.assetDefId != null && adoptedDevice.assetDefId != -1">
                                <el-radio class="radio mr10" :label="true">是</el-radio>
                                <el-radio class="radio" :label="false">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>名称</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="name">
                            <el-input class="width-2x " :disabled="adoptedDevice.skuId != -1 && adoptedDevice.skuId != null" v-model="adoptedDevice.name"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>型号</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="model">
                            <el-input class="width-2x " :disabled="adoptedDevice.skuId != -1 && adoptedDevice.skuId != null" v-model="adoptedDevice.model"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>规格</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="fixedSpec">
                            <el-input class="width-2x " :disabled="adoptedDevice.skuId != -1 && adoptedDevice.skuId != null" v-model="adoptedDevice.fixedSpec"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>质保期(月)</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="wrntPeriod">
                            <el-input type="number" class="width-2x " :disabled="adoptedDevice.skuId != -1 && adoptedDevice.skuId != null" v-model="adoptedDevice.wrntPeriod"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <!--<div v-if="adoptedDevice.goodsCatId == null" class="form-group center">
                    <div class="form-label">
                        <label>单位</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="unit">
                            <el-input class="width-2x " :disabled="adoptedDevice.skuId != -1 && adoptedDevice.skuId != null" v-model="adoptedDevice.unit"></el-input>
                        </el-form-item>
                    </div>
                </div>-->
            </div>
            <div class="content-caption dashed">
                <span>价格信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label>税率</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="taxRate">
                            <el-input type="number" class="width-2x " @blur="changeNtxPrice" v-model="adoptedDevice.taxRate"></el-input>
                            <div class="form-tips">%</div>
                        </el-form-item>
                    </div>
                </div>
                <template v-if="bizAreaList.length <= 0 || adoptedDevice.contractEnded">
                    <div class="form-group center">
                        <div class="form-label">
                            <label>含税价</label>
                        </div>
                        <div class="form-value " v-if="!adoptedDevice.contractEnded">
                            <el-form-item prop="price">
                                <el-input type="number" class="width-2x " :disabled="adoptedDevice.skuId != -1 && adoptedDevice.skuId != null " @blur="changePrice" v-model="adoptedDevice.price"></el-input>
                                <div class="form-tips">元</div>
                            </el-form-item>
                        </div>
                        <div class="form-value " v-else>
                            <el-form-item prop="price">
                                <el-input type="number" class="width-2x " @blur="changePrice" v-model="adoptedDevice.price"></el-input>
                                <div class="form-tips">元</div>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label>未税价</label>
                        </div>
                        <div class="form-value">
                            <el-form-item prop="price2">
                                <el-input class="width-2x bottom-line" :disabled="true" v-model="adoptedDevice.ntxPrice"></el-input>
                                <div class="form-tips">元</div>
                            </el-form-item>
                        </div>
                    </div>
                </template>
            </div>
            <div class="content-caption dashed">
                <span>经营区域信息</span>
                <a class="swb-btn-link" @click="selectBizAreaInfo()">选择</a>
            </div>
            <template v-if="adoptedDevice.id == null">
                <div class="table-layout">
                    <el-table ref="multipleTable" :data="bizAreaList" border tooltip-effect="dark" style="width: 100%">
                        <el-table-column align="left" prop="bizAreaName" label="名称"></el-table-column>
                        <el-table-column align="left" prop="bizAreaCode" label="编码"></el-table-column>
                        <el-table-column align="center" width="110" prop="price" label="含税价">
                            <template slot-scope="scope">
                                <el-form-item>
                                    <el-input v-model.number="scope.row.price" @change="priceChange(scope.$index);"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="110" prop="ntxPrice" label="未税价">
                            <template slot-scope="scope">
                                <span> {{scope.row.ntxPrice}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="110" prop="bizFormName" label="经营业态">
                            <template slot-scope="scope">
                                <span v-if="id != null"> {{scope.row.ntxPrice}}</span>
                                <span v-else>
                                        <template v-if="scope.row.bizFormList != null && scope.row.bizFormList.length > 0" v-for="(bizForm, index) in scope.row.bizFormList">
                                            <span class="swb-tags swb-tags-success mr5">{{bizForm.bizFormName}}</span>
                                        </template>
                                    </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" label="操作">
                            <template slot-scope="scope">
                                <a class="swb-btn-link" @click="removeAreaPrice(scope.$index)">移除</a>
                                <a class="swb-btn-link" @click="setAreaFrom(scope.$index)">设置经营业态</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </template>
            <template v-else>
                <div class="simple-form">
                    <div class="form-group center">
                        <div class="form-label">
                            <label>代码</label>
                        </div>
                        <div class="form-value ">
                            <el-form-item prop="name">
                                <span>{{adoptedDevice.bizAreaCode}}</span>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label>名称</label>
                        </div>
                        <div class="form-value">
                            <el-form-item prop="fixedSpec">
                                <span>{{adoptedDevice.bizAreaName}}</span>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="bizAreaList.length <= 0">
                <div class="content-caption dashed">
                    <span>经营业态信息</span>
                    <a class="swb-btn-link" @click="selectBizFormInfo()">选择</a>
                </div>
                <div class="simple-form">
                    <div class="form-group center">
                        <div class="form-label">
                            <label>名称</label>
                        </div>
                        <div class="form-value">
                            <el-form-item v-if="adoptedDevice.id != null">
                                <span>{{adoptedDevice.bizFormName}}</span>
                            </el-form-item>
                            <el-form-item v-if="adoptedDevice.id == null">
                                <template v-if="bizFormList != null && bizFormList.length > 0" v-for="(bizForm, index) in bizFormList">
                                    <span class="swb-tags swb-tags-success mr5">{{bizForm.bizFormName}}</span>
                                </template>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </template>
            <div class="content-caption dashed">
                <span>其他</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label>星级</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="favorLevel">
                            <el-rate v-model="adoptedDevice.favorLevel"></el-rate>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>到货天数</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="arriveDays">
                            <el-input type="number" class="width-2x " v-model="adoptedDevice.arriveDays"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>备注</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="memo">
                            <el-input class="width-2x" v-model="adoptedDevice.desc" type="textarea" placeholder="请输入备注信息"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { GoodsCategAndBrandSelectDlg } from './dialog'
    import { openBizFormSelectionDlg } from '../bizForm/selectDlg'
    import { showRetailerBizAreaSelectDlg } from '../bizArea/dialog'
    import devcReqrApi from '../../api/devcReqr'
    import ElRadio from '../../../node_modules/element-ui/packages/radio/src/radio';
    //
    export default {
        components: {ElRadio}, name: 'swb-adopted-device-save',
        desc: '采购入选商品-保存',
        props: ["id"],
        data: function () {
            var checkFixedSpec = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback()
                } else {
                    if(value.length > 45) {
                        callback(new Error("规格不可大于45"))
                    } else {
                        callback()
                    }
                }
            };
            var checkModel = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback()
                } else {
                    if(value.length > 30) {
                        callback(new Error("规格不可大于30"))
                    } else {
                        callback()
                    }
                }
            };
            var checkPrice = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback()
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error("请填写正确的含税价"))
                    } else {
                        callback()
                    }
                }
            };
            var checkTaxRate = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback()
                } else {
                    if(!Utils.isMoneyStr(value) || value > 100) {
                        callback(new Error("请填写正确的税率"))
                    } else {
                        callback()
                    }
                }
            };
            var checkArriveDays = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback()
                } else {
                    if(!Utils.isNaturalStr(value, true)) {
                        callback(new Error("请填写正确的到货天数"))
                    } else {
                        callback()
                    }
                }
            };
            var checkWrntPeriod = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback()
                } else {
                    if(!Utils.isNaturalStr(value, true)) {
                        callback(new Error("请填写正确的质保期"))
                    } else {
                        callback()
                    }
                }
            };
            return {
                adoptedDevice: {
                    asmblAccFlag: false
                },
                bizAreaList: [],
                bizFormList: [],
                adoptedDeviceRules: {
                    fixedSpec: [{validator: checkFixedSpec, trigger: 'blur'}],
                    model: [{validator: checkModel, trigger: 'blur'}],
                    price: [{validator: checkPrice, trigger: 'blur'}],
                    taxRate: [{validator: checkTaxRate, trigger: 'blur'}],
                    arriveDays: [{validator: checkArriveDays, trigger: 'blur'}],
                    wrntPeriod: [{validator: checkWrntPeriod, trigger: 'blur'}],
                }
            }
        },
        created: function () {
            if(!Utils.isNoB(this.id)) {
                this.getAdoptedDeviceById(this.id);
            }
        },
        methods: {
            // 根据id查询对应的信息
            getAdoptedDeviceById: function (id) {
                let self = this;
                let postData = {
                    id: id
                };
                devcReqrApi.getAdoptedDevice(postData, function (result) {
                    if(result.type == "info") {
                        self.adoptedDevice = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            /**
             * 选择分类和品牌
             */
            selectCatInfo: function () {
                let self = this;
                let adoptedDevice = self.adoptedDevice;
                GoodsCategAndBrandSelectDlg(null, function (result) {
                    console.log(result);
                    adoptedDevice.goodsCatId = result.cat.id;
                    adoptedDevice.goodsCatName = result.cat.name;
                    adoptedDevice.goodsBrandId = result.catBrand.brandId;
                    adoptedDevice.goodsBrandName = result.catBrand.brand.name;
                    adoptedDevice.name = result.cat.name + result.catBrand.brand.name;
                    self.adoptedDevice = Utils.merge({}, adoptedDevice);
                })
            },
            changePrice: function () {
                let adoptedDevice = this.adoptedDevice;
                let price = adoptedDevice.price;
                if(Utils.isNoB(adoptedDevice.taxRate) || adoptedDevice.taxRate == 0) {
                    adoptedDevice.ntxPrice = price;
                } else {
                    adoptedDevice.ntxPrice = ( adoptedDevice.price / (1 + (adoptedDevice.taxRate * 0.01))).toFixed(2);
                }
                this.adoptedDevice = Utils.merge({}, adoptedDevice);
            },
            changeNtxPrice: function () {
                let adoptedDevice = this.adoptedDevice;
                if(this.bizAreaList.length > 0) {
                    let bizAreaList = this.bizAreaList || [];
                    for(let i = 0; i < bizAreaList.length; i++) {
                        let bizArea = bizAreaList[i];
                        if(!Utils.isNoB(bizArea.price)) {
                            bizArea.ntxPrice = ( bizArea.price / (1 + (adoptedDevice.taxRate * 0.01))).toFixed(2);
                        }
                        bizArea.taxRate = adoptedDevice.taxRate;
                    }
                    this.bizAreaList = Utils.merge([], bizAreaList);
                } else {
                    if(!Utils.isNoB(adoptedDevice.price) && !Utils.isNoB(adoptedDevice.taxRate)) {
                        adoptedDevice.ntxPrice = ( adoptedDevice.price / (1 + (adoptedDevice.taxRate * 0.01))).toFixed(2);
                    }
                }
                this.adoptedDevice = Utils.merge({}, adoptedDevice);
            },
            // 选择经营区域
            selectBizAreaInfo: function () {
                let self = this;
                let bizAreaList = self.bizAreaList || [];
                let adoptedDevice = self.adoptedDevice;
                let bizAreaIds = bizAreaList.pluck("bizAreaId") || [];
                let checkBox = true;
                if(!Utils.isNoB(this.id)) {
                    checkBox = false;
                }
                let parmas = {
                    selectIds: bizAreaIds,
                    checkBox: checkBox
                };
                showRetailerBizAreaSelectDlg(parmas, function (bizAreaList, theDlg) {
                    theDlg.close();
                    bizAreaList = bizAreaList || [];
                    if(Utils.isNoB(self.id)) {
                        let bizAreaItemList = [];
                        for(let i = 0; i < bizAreaList.length; i++) {
                            let bizArea = bizAreaList[i];
                            let areaPrice = {
                                bizAreaId: bizArea.id,
                                bizAreaName: bizArea.name,
                                bizAreaCode: bizArea.code,
                                price: null,
                                ntxPrice: null
                            };
                            bizAreaItemList.push(areaPrice);
                        }
                        adoptedDevice.price = null;
                        adoptedDevice.ntxPrice = null;
                        self.bizAreaList = Utils.merge([], bizAreaItemList);
                        self.adoptedDevice = Utils.merge({}, adoptedDevice);
                    } else {
                        adoptedDevice.bizAreaId = bizAreaList.id;
                        adoptedDevice.bizAreaName = bizAreaList.name;
                        adoptedDevice.bizAreaCode = bizAreaList.code;
                    }

                });
            },
            // 移除经营区域
            removeAreaPrice: function (index) {
                let bizAreaList = this.bizAreaList || [];
                bizAreaList.splice(index, 1);
                this.bizAreaList = Utils.merge([], bizAreaList);
            },
            priceChange: function (index) {
                let bizAreaList = this.bizAreaList || [];
                let bizArea = bizAreaList[index];
                let taxRate = this.adoptedDevice.taxRate;
                if(taxRate != null) {
                    bizArea.ntxPrice = ( bizArea.price / (1 + (taxRate * 0.01))).toFixed(2);
                } else {
                    bizArea.ntxPrice = bizArea.price;
                }
                this.bizAreaList = Utils.merge([], bizAreaList);
            },
            setAreaFrom: function (index) {
                let self = this;
                let bizAreaList = self.bizAreaList || [];
                let bizArea = bizAreaList[index];
                let bizFormList = bizArea.bizFormList || [];
                let checkedIds = bizFormList.pluck("bizFormId") || [];
                let isShowSelection = true;
                if(!Utils.isNoB(self.id)) {
                    isShowSelection = false;
                }
                let params = {
                    checkedIds: checkedIds,
                    isShowSelection: isShowSelection
                };
                openBizFormSelectionDlg(params, function (bizFormList, theDlg) {
                    //
                    bizFormList = bizFormList || [];
                    if(bizFormList.length > 5) {
                        MsgBox.warning("最多可设置5个经营业态！");
                        return;
                    }
                    theDlg.close();
                    let bizFromItemList = [];
                    for(let i = 0; i < bizFormList.length; i++) {
                        let bizForm = bizFormList[i];
                        let bizFormItem = {
                            bizFormId: bizForm.id,
                            bizFormName: bizForm.name,
                            bizFormCode: bizForm.code,
                        };
                        bizFromItemList.push(bizFormItem);
                    }
                    bizArea.bizFormList = Utils.merge([], bizFromItemList);
                    self.bizAreaList = Utils.merge([], bizAreaList);
                });

            },
            selectBizFormInfo: function () {
                let self = this;
                let adoptedDevice = self.adoptedDevice;
                let bizFormList = this.bizFormList;
                let checkedIds = bizFormList.pluck("bizFormId") || [];
                let isShowSelection = true;
                if(!Utils.isNoB(this.id)) {
                    isShowSelection = false;
                }
                let params = {
                    checkedIds: checkedIds,
                    isShowSelection: isShowSelection
                };
                openBizFormSelectionDlg(params, function (bizFormList, theDlg) {
                    //
                    bizFormList = bizFormList || [];
                    if(Utils.isNoB(self.id)) {
                        if(bizFormList.length > 5) {
                            MsgBox.warning("最多可设置5个经营业态！");
                            return;
                        }
                        theDlg.close();
                        let bizFromItemList = [];
                        for(let i = 0; i < bizFormList.length; i++) {
                            let bizForm = bizFormList[i];
                            let bizFormItem = {
                                bizFormId: bizForm.id,
                                bizFormName: bizForm.name,
                                bizFormCode: bizForm.code,
                            };
                            bizFromItemList.push(bizFormItem);
                        }
                        //
                        self.bizFormList = Utils.merge([], bizFromItemList);
                    } else {
                        theDlg.close();
                        adoptedDevice.bizFormId = bizFormList.id;
                        adoptedDevice.bizFormName = bizFormList.name;
                        adoptedDevice.bizFormCode = bizFormList.code;
                        self.adoptedDevice = Utils.merge({}, adoptedDevice);
                    }

                });
            },
            getDlgResult: function () {
                let result = {};
                let self = this;
                let adoptedDevice = self.adoptedDevice;
                this.$refs['adoptedDeviceInfo'].validate(function (valid) {
                    if(valid) {
                        if(!Utils.isNoB(adoptedDevice.fixedSpec) && !Utils.isNoB(adoptedDevice.model)) {
                            let fixedModel = adoptedDevice.model + adoptedDevice.fixedSpec;
                            if(fixedModel.length > 60) {
                                result.type = "warn";
                                result.message = "型号规格不可大于60个字";
                                return result;
                            }
                        }
                        if(Utils.isNoB(adoptedDevice.goodsCatId)) {
                            result.type = "warn";
                            result.message = "请选择分类信息";
                        } else {
                            if(Utils.isNoB(self.id)) {
                                let adoptedDeviceList = [];
                                let bizAreaList = self.bizAreaList || [];
                                if(bizAreaList.length > 0) {
                                    for(let i = 0; i < bizAreaList.length; i++) {
                                        let device = JSON.decode(JSON.encode(adoptedDevice));
                                        let bizArea = bizAreaList[i];
                                        device.bizAreaId = bizArea.bizAreaId;
                                        device.bizAreaCode = bizArea.bizAreaCode;
                                        device.bizAreaName = bizArea.bizAreaName;
                                        device.price = bizArea.price;
                                        device.ntxPrice = bizArea.ntxPrice;
                                        let bizFormList = bizArea.bizFormList;
                                        if(!Utils.isNoB(bizFormList) && bizFormList.length > 0) {
                                            let bizFormIds = bizFormList.pluck("bizFormId");
                                            device.bizFormIds = bizFormIds;
                                        }

                                        adoptedDeviceList.push(device);
                                    }
                                } else {
                                    let bizFormList = self.bizFormList || [];
                                    let bizFormIds = bizFormList.pluck("bizFormId");
                                    adoptedDevice.bizFormIds = bizFormIds;
                                    adoptedDeviceList.push(adoptedDevice);
                                }

                                console.log(JSON.encode(adoptedDeviceList));
                                result.data = adoptedDeviceList;
                            } else {
                                result.data = adoptedDevice;
                            }
                            result.type = "info";
                        }
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                return result;
            },
        }
    }

</script>
<style>
    .adopted-device .el-tree.el-tree--highlight-current {
        height: 400px;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// src/compo/retailer/AdoptedDeviceSave.vue